<template>
<div class="doc-product-page ">
  <div class="bg-grey">
   <TitleBar :msg="msg"/>
   <div class="row-container doc1">
    <ul>
      <li><span class="management-icon" style="background-position:0 0"></span><span>文件管理</span><p class="des">按照企业特点自定义文档元数据，树状形目录结构，层级划分，自定义标签，属性分类，按企业所需，自行定义，支持文件档案一系列完整生命周期</p></li>
      <li><span class="management-icon" style="background-position:-2rem 0"></span><span>档案建设</span><p class="des">实现档案的一体化管理，依据统一的标准规范，将文件从形成、运转、处理到档案的收集、整理、检索、利用等各环节有机结合起来，组成一个系统</p></li>
      <li><span class="management-icon" style="background-position:-4rem 0"></span><span>OCR识别</span><p class="des">JPG、TIF、PNG、PDF各种图片格式的扫描文档上传后，后台自动进行OCR文字识别，能直接通过图片内文字进行检索，且支持高级检索功能</p></li>
      <li><span class="management-icon" style="background-position:-6rem 0"></span><span>全文检索</span><p class="des">对文件档案只有模糊记忆便可从海量文件档案中获取所需文件档案，极大减少了因查找困难浪费的工作时间</p></li>
      <li><span class="management-icon" style="background-position:-8rem 0"></span><span>在线预览</span><p class="des">在权限范围内可以直接在线预览文件内容，包括Excel,Word,PPT,CAD等，无需下载，无需打印，方便用户使用</p></li>
      <li><span class="management-icon" style="background-position:0 -2rem"></span><span>权限控制</span><p class="des">可针对用户、部门及岗位进行细腻的权限控制，控制用户的管理、浏览、阅读、编辑、下载、删除、打印等操作</p></li>
      <li><span class="management-icon" style="background-position:-2rem -2rem"></span><span>自定义水印</span><p class="des">文档进行预览、打印和下载时可显示水印标签，水印可以包含用户账号、姓名、日期时间、所在部门或其他自主定义的字符串</p></li>
      <li><span class="management-icon" style="background-position:-4rem -2rem"></span><span>批量导入</span><p class="des">档案条目可通过Excel文件批量导入，档案附件原文可以批量挂接，省去手工录入的麻烦，提高工作效率，保障录入准确性</p></li>
      <li><span class="management-icon" style="background-position:-6rem -2rem"></span><span>手机移动端</span><p class="des">支持安卓、IOS、PDA等移动设备多端登录，协同管理，便捷查询文件、档案，搜索文档、在线预览，文档借阅、在线审批等操作</p></li>
    </ul>
   </div>
   <div class="buttonzu">
     <el-button class="border-button"  @click="openDocProduct" >了解更多</el-button>
     <el-button type="primary" @click="openConsultBox">免费试用</el-button>
   </div>
  </div>
  <div style="position:relative;" class="doc2" >
    <div class="text">
      <p class="title1">档案批量导入</p>
      <p class="title2">档案条目可通过Excel文件批量导入，档案附件原文可以批量挂接，省去手工录入的麻烦</p>
      <el-button class="border-button"  @click="openConsultBox">免费试用</el-button>
    </div>
    <img :src="aimg" alt="" style="width:100%;">
  </div>
  <div class="doc3">
    <div class="imgright">
     <img :src="aimg1" alt="">
    </div>
    <div class="content">
      <p class="title1">领先的自定义模型框架</p>
      <p class="title2">实现门类、著录项、权限等全方位自由设计，灵活满足客户各种深度定制需求</p>
      <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
    </div>
  </div>
  <div style="background-color:#f5f7fa;">
    <div class="doc3 doc-right" >
      <div class="content">
        <p class="title1">毫秒级的全文搜索</p>
        <p class="title2">对文档只有模糊记忆便可从海量文档中获取所需文档，极大减少了因查找困难浪费的工作时间</p>
        <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
      </div>
      <div class="imgright">
      <img :src="aimg2" alt="">
      </div>
    </div>
  </div>
  <div class="doc3">
    <div class="imgright">
     <img :src="aimg3" alt="">
    </div>
    <div class="content">
      <p class="title1">精准高效的文字OCR识别</p>
      <p class="title2">扫描件通过OCR文字识别后能自动索引，识别准确率高</p>
      <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
    </div>
  </div>
  <div style="position:relative;" class="doc2 blackbg">
    <div class="text">
      <p class="title1">智能档案室，管理科学化、设备智能化</p>
      <p class="title2">将档案管理系统、环境系统、安防系统以及所有相关的硬件设备之间进行连接交互，实现了一个智能化、高效化、简洁化的档案管理方案</p>
    </div>
    <img :src="aimgb" alt="" style="width:100%;margin-top:160px;">
  </div>
  <div class="doc4">
    <TitleBar :msg="msg2"/>
    <ul>
      <li><router-link to="/docsolution/1"><img :src='faimg[0]' alt=""><p>档案数字化服务</p></router-link></li>
      <li><router-link to="/docsolution/2"><img :src='faimg[1]' alt=""><p>文件管理系统</p></router-link></li>
      <li><router-link to="/docsolution/3"><img :src='faimg[2]' alt=""><p>移动APP档案管理系统</p></router-link></li>
      <li><router-link to="/docsolution/4"><img :src='faimg[3]' alt=""><p>智慧档案室</p></router-link></li>
      <li><router-link to="/docsolution/5"><img :src='faimg[4]' alt=""><p>房地产行业档案管理</p></router-link></li>
      <li><router-link to="/docsolution/6"><img :src='faimg[5]' alt=""><p>会计行业档案管理</p></router-link></li>
    </ul>
  </div>
  <div style="background-color:#f5f7fa;">
    <div class="doc5">
       <TitleBar :msg="msg3"/>
      <ul>
        <li> <router-link to="/products/9"><span class="management-icon" style="background-position:0 -6rem;"></span><p class="title1">文件档案管理系统<span class="arrow-icon"></span></p><p class="des">实现文件从生成、审批、发布、归档到销毁的全流程电子化管理</p></router-link></li>
        <li> <router-link to="/products/25"><span class="management-icon" style="background-position:-3.5rem -6rem;"></span><p class="title1">GMP文档管理系统<span class="arrow-icon"></span></p><p class="des">针对医药行业GMP规范设计，确保药品生产全过程的可追溯性和数据完整性</p></router-link></li>
        <li> <router-link to="/products/27"><span class="management-icon" style="background-position:-7rem -6rem;"></span><p class="title1">ISO文控管理系统<span class="arrow-icon"></span></p><p class="des">专为ISO体系打造，帮助企业建立符合标准的文件控制流程</p></router-link></li>
        <li> <router-link to="/handwareProducts"><span class="management-icon" style="background-position:-10.5rem -6rem;"></span><p class="title1">相关硬件搭配<span class="arrow-icon"></span></p><p class="des">所需的相关硬件，包括条码打印机/扫描枪/高速扫描仪等</p></router-link></li>
      </ul>
    </div>
  </div>
 
</div>
</template>
<script>
import TitleBar from '../components/TitleBar.vue'

import a from '../assets/docbanner1.png'
import b from '../assets/docbanner2.png'
import a1 from '../assets/XT1.png'
import a2 from '../assets/XT2.png'
import a3 from '../assets/XT3.png'
import fa1 from '../assets/FA1.png'
import fa2 from '../assets/FA2.png'
import fa3 from '../assets/FA3.png'
import fa4 from '../assets/FA4.png'
import fa5 from '../assets/FA5.png'
import fa6 from '../assets/FA6.png'
import { get, imageFile } from '../plugins/request.js'
import getQueryString from '../plugins/getQueryString.js'

export default {
  name: 'docProductPage',
  components: {
    TitleBar
  },
  data() {
    return {
      msg: {
        title: '数字化文件档案一体化管理',
        subTitle: '强大的系统功能，优质的用户体验'
      },
      msg2: {
        title: '解决方案',
        subTitle: '根据流程和需求，量身定制个性化解决方案'
      },
      msg3: {
        title: '更多的相关软件产品',
        subTitle: '软件系统和硬件搭配方案，文档全生命周期的智能化管理'
      },
      aimg:a,
      aimg1:a1,
      aimg2:a2,
      aimg3:a3,
      aimgb:b,
      faimg:[fa1,fa2,fa3,fa4,fa5,fa6],
      items: [
        { title: '', des: '' },
        { title: '', des: '' },
        { title: '', des: '' }
      ]
    }
  },
  methods: {
    openConsultBox(){
      window.$crisp.push(['do', 'chat:open']);
    },
    openDocProduct(){
      this.$router.push('/products/9')
    }
  },
  created: function(){
   
  },
  
}
</script>
<style lang="scss">
.doc-product-page {
  font-size: 0.8rem;
  line-height: 2;
  .bg-grey{
    background: #f5f7fa;
    padding-bottom: 2.5rem;
  }
  .buttonzu{
    text-align: center;
    margin-top: 1.5rem;
    .el-button.border-button{
      color: #444444;
    }
    .el-button.border-button:hover{
      border-color: #409EFF !important;
      background-color:transparent !important;
      color: #409EFF !important;
    }
  }
  
  .doc1{
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        background:#fff;
        border-radius: 4px;
        display: inline-block;
        flex: 0 1 30%;
        font-size: 14px;
        padding: 1rem 2rem;
        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
        margin-bottom: 2rem;
        word-break: break-all;
        span{
          font-size: 20px;
          font-weight: 600;
          
        }
        p{
          line-height: 20px;
        }
        .des{
          margin-top: 0.7rem;
        }
      }
    }
    .management-icon{
      display: inline-block;
      width: 2rem;
      height: 2rem;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:0 0;
      border: 0;
      background-size: 500%;
      vertical-align: -10px;
      margin-right: 10px;
    }
  }
  .doc2{
    .text{
      width: 1440px;
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      color: #fff;
      text-align: left;
      padding:0 2rem;
      .title1{
        font-size: 36px;
        font-weight: 600;
      }
      .title2{
        width: 22rem;
        margin-bottom: 2rem;
        line-height: 1.4;
      }
    }
    &.blackbg{
      background: #22273d;
      .text{
        text-align: center;
        top: 20%;
        .title2{
          width: 100%;
        }
      }
    }
    
  }
  
  .doc3{
    display: flex;
    justify-content: space-between;
    max-width: 1300px;
    padding-left:0;
    padding-right:3rem;
    margin: 0 auto;
    align-items: center;
    &.doc-right{padding-left:3rem;padding-right:0;}
    .content{
      .title1{
        margin-bottom: 10px;
        font-size:32px;
        font-weight: 600;
      }
      .title2{
        font-size:20px;
        color:#353535;
        line-height: 1.4;
        width: 340px;
      }
    }
  }
  .doc4{
    max-width: 1400px;
    margin: 0 auto;
    text-align: center;
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        display: inline-block;
        flex: 0 1 30%;
        font-size: 14px;
        border-radius: 6px;
        p{
          font-size: 18px;
          margin-bottom: 2rem;
        }
      }
      li:hover img{
        box-shadow: 0 8px 20px 0 rgba(55, 99, 170, .2);}
    }
  }
  .doc5{
    text-align: center;
    margin: 0 auto;
    max-width: 1400px;
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        background:#fff;
        border-radius: 4px;
        display: inline-block;
        flex: 0 1 46%;
        margin-bottom: 2.5rem;
        a{
          display: block;
          text-align: left;
          font-size: 16px;
          padding: 2rem 2rem;
          .title1{
            font-size: 20px;
            font-weight: 600;
          }
        }
      }
      li:hover{
        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
        .title1{
          color: #2a7acc;
        }
         .arrow-icon{
          background-position:-280px -137px;
        }
      }
    }
    .management-icon{
      display: inline-block;
      width: 3.2rem;
      height: 3.2rem;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:0 0;
      border: 0;
    }
    .arrow-icon{
      display: inline-block;
      width: 10px;
      height: 18px;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:-280px -120px;
      margin-left: 10px;
      vertical-align: -1px;
    }
  }
  
}
</style>